import React from 'react';
import PropTypes from 'prop-types'
import ReactTable from 'react-table';

import GrowthChart from './GrowthChart';
import { 
	getAnnualizedReturns, 
	getStandardDeviation, 
	getTotalReturns, 
	getFormattedPercent, 
	getFormattedStandardDeviation,
	getFormattedCurrency
 } from './utils';

import 'react-table/react-table.css';

const IndexDetail = ({ startYear, endYear, numberOfYears, chartData, currencyCode }) => {
	const annualizedReturns = getAnnualizedReturns(chartData);
	const standardDeviation = getStandardDeviation(chartData);
	const totalReturns = getTotalReturns(chartData);
	const growthOfDollar = getFormattedCurrency(chartData[chartData.length - 1].growthOfDollar, 2, currencyCode);
	const data = [
		{ name: 'Investment Period', val: `${startYear} - ${endYear}` },
		{ name: 'Duration', val: numberOfYears },
		{ name: 'Annualized Return', val: `${getFormattedPercent(annualizedReturns)}` },
		{ name: 'Standard Deviation', val: `${getFormattedStandardDeviation(standardDeviation)}` },
		{ name: 'Total Return', val: `${getFormattedPercent(totalReturns)}` }
	];
	return (
		<React.Fragment>
			<div style={{ width: '50%', float: 'left', padding: '1%' }}>
				<ReactTable
					data={data}
					columns={[
						{
							// Header: "Detail Name",
							accessor: 'name',
							className: 'text-left'
						},
						{
							// Header: "Detail val",
							accessor: 'val',
							className: 'text-right'
						}
					]}
					defaultPageSize={data.length}
					className="-striped -highlight"
					showPagination={false}
					TheadComponent={() => null}
				/>
			</div>
			{/* TODO: chart height can be the maximum available height on container */}
			<div style={{ width: '50%', float: 'left', padding: '1%', height: '335px' }}>
				<GrowthChart 
					chartData={chartData}
					growthOfDollar={growthOfDollar}
					currencyCode={currencyCode} 
				/>
			</div>
		</React.Fragment>
	);
};

IndexDetail.propTypes = {
	startYear: PropTypes.number.isRequired,
	endYear: PropTypes.number.isRequired,
	numberOfYears: PropTypes.string.isRequired,
	chartData: PropTypes.array.isRequired, // todo define shape
	currencyCode: PropTypes.string.isRequired, // todo define shape
};

export default IndexDetail;
